<template>
    <section class="card flex-container my-4">
        <div class="flex gap-2">
            <h3 class="font-semibold">{{ descricao ? descricao : 'Estado dos pneus' }}</h3>
            <Status v-if="!resumoModulos" :status="statusResposta" />
        </div>
        <div v-if="!resumo">
            <h4 class="">Selecione a quantidade de eixos:</h4>
            <div class="flex items-center flex-wrap gap-2">
                <div class="w-24 h-12 botao-padrao botao-selecionado">
                    <img class="w-10" :src="require('@/assets/eixos.png')"
                        alt="Desenho de um veículo do tipo automovel" />
                </div>
                <button class="w-24 h-12 botao-padrao botao-eixo" @click="adicionarEixo">
                    <Icone :nome="'add_circle'" /> 1 eixo
                </button>
            </div>
            <div class="divide-y divide-dashed divide-gray-300 mt-2">
                <div v-for="{ descricao, id, estadoSelecionado } in estadosPneus" :key="id">
                    <div class="mt-2">
                        <span class="font-medium">{{ descricao }}</span>
                    </div>
                    <div class="flex justify-between m-2 gap-2">
                        <div v-for="{ estado, imagem } in estadosValoresEnum" :key="estado"
                            class="flex flex-col items-center">
                            <button class="w-14 h-14 botao-padrao botao-desabilitado"
                                :class="estadoSelecionado === estado ? estadoSelecionado.toLowerCase() : ''"
                                @click="atribuirEstadoPneu(id, estado)">
                                <img :src="imagem" alt="" class="w-10 h-10">
                            </button>
                            <div>
                                <span class="text-sm">{{ estado }}</span>
                            </div>
                        </div>
                    </div>
                    <div v-if="descricao != 'Dianteiro' && descricao != 'Traseiro'"
                        class="flex items-center justify-center my-2 text-[#FF4D4F] cursor-pointer"
                        @click="removerEixo(id)">
                        <span class="text-sm">Remover eixo</span>
                        <Icone :nome="'delete'" />
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="grid grid-cols-3 gap-2 mt-3 flex-wrap justify-around">
            <div v-for="{ descricao, id, estadoSelecionado } in estadosPneus" :key="id" class="flex flex-col justify-between items-center">
                <span class="font-semibold">{{ descricao }}</span>
                <div v-for="{ estado, imagem } in estadosValoresEnum" :key="estado" class="flex flex-col items-center">
                    <div v-if="estadoSelecionado === estado" class="flex items-center justify-center w-12 h-12 rounded-md shadow"
                        :class="estadoSelecionado.toLowerCase()">
                        <img :src="imagem" alt="" class="w-10 h-10">
                    </div>
                    <div v-if="estadoSelecionado === estado">
                        <span class="text-sm">{{ estado }}</span>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { defineComponent } from 'vue'
import PropsComponentesConstant from '@/constants/PropsComponentesConstant';
import Icone from '@/components/Icone.vue';
import Status from '@/components/Status.vue';
import ComponenteEstadoPneuService from '@/services/componentes/ComponenteEstadoPneuService';
import FuncoesHelper from '@/helpers/FuncoesHelper';
import ComponentesService from '@/services/ComponentesService';

export default defineComponent({
    name: 'EstadoPneu',
    components: {
        Icone,
        Status
    },
    props: {
        ...PropsComponentesConstant.PROPS,
    },
    methods: {
        adicionarEixo() {
            this.estadosPneus.push({
                descricao: this.estadosPneus.length == 2 ? 'Estepe' : `Eixo alternativo`,
                estadoSelecionado: 'Regular',
                id: FuncoesHelper.gerarUuid()
            })
            ComponentesService.salvarRespostaEstadoComponente(this.modulo, this.etapaComponente, this.identificador, this.estadosPneus)
            setTimeout(() => {
                window.scrollTo({
                    top: document.body.scrollHeight,
                    behavior: 'smooth'
                });
            }, 100)
        },
        atribuirEstadoPneu(id, valor) {
            this.estadosPneus.forEach(pneu => {
                if (pneu.id === id) {
                    pneu.estadoSelecionado = valor
                    ComponentesService.salvarRespostaEstadoComponente(this.modulo, this.etapaComponente, this.identificador, this.estadosPneus)
                    this.statusResposta = ComponentesService.validaStatusRespostaComponente(this.respostaObrigatoria, true)
                }
            })
        },
        removerEixo(id) {
            const index = this.estadosPneus.findIndex(pneu => pneu.id === id)
            if (index > -1) {
                this.estadosPneus.splice(index, 1)
                ComponentesService.salvarRespostaEstadoComponente(this.modulo, this.etapaComponente, this.identificador, this.estadosPneus)
            }
        }
    },
    setup(props) {
        return ComponenteEstadoPneuService.setup(props)
    }
})
</script>

<style scoped>
.regular {
    @apply bg-[#6e5dc633] border-[#917bff] text-[#917bff] hover:ring-[#917bff];
}

.ruim {
    @apply bg-[#f08f92] border-[#CC0003] hover:ring-vermelho-padrao;
}

.bom {
    @apply bg-[#c3f5cd] border-verde-sucesso hover:ring-verde-sucesso;
}
</style>